module.exports = __webpack_public_path__ + "static/img/9.bba4b85.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/9.png
// module id = n8iW
// module chunks = 0